<template>
  <el-dialog
    :visible.sync="innerVisible"
    width="312px"
    custom-class="kefu-dialog"
    :show-close="false"
    append-to-body
  >
    <div class="kefu-inner">
      <p class="kefu-title">{{ text.kefuTitle }}</p>
      <p class="kefu-tip">{{ text.kefuWechatTip }}</p>
      <div class="kefu-img-wrap">
        <img
          v-if="wechatImg"
          class="kefu-wechat"
          :src="wechatImg"
          alt="客服微信"
        />
      </div>
      <div class="kefu-phone-box">
        <p class="phone-label">{{ text.kefuPhoneTip }}</p>
        <p class="phone">{{ phone }}</p>
      </div>
      <i class="kefu-close" @click="close"></i>
    </div>
  </el-dialog>
</template>
<script>
import { PRO_PLAN_TEXT } from "@/consts/proPlan";
import { subject } from "@/api/request/snkd.operate";

/**
 * 咨询客服弹框（加客服微信 / 电话咨询）
 * 数据来自运营商配置接口，与老端 initKefu 弹框内容一致；
 * 未提供二维码时退化为调用本地缓存 subjectVO（老端登录后写入），避免空框。
 */
export default {
  name: "ProPlanKefuDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      text: PRO_PLAN_TEXT,
      wechatImg: "",
      phone: "",
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchSubject();
        // 弹框内垂直居中：Element UI 的 el-dialog 不支持给 wrapper 加 class，
        // 只能拿到 DOM 后打标（配合 .kefu-dialog-wrapper 的 flex + margin:auto）
        this.$nextTick(this.markWrapper);
      }
    },
  },
  methods: {
    markWrapper() {
      const dialog = this.$el;
      const wrapper = dialog && dialog.closest(".el-dialog__wrapper");
      if (wrapper) wrapper.classList.add("kefu-dialog-wrapper");
    },
    async fetchSubject() {
      const cached = this.readCachedSubject();
      this.applySubject(cached);
      try {
        const res = await subject.getService();
        if (res.respCode === 0) {
          this.applySubject((res.obj && res.obj.subjectVO) || res.obj);
        }
      } catch (e) {
        console.log(e);
      }
      if (!this.wechatImg && !this.phone) {
        this.$message.info(this.text.kefuUnavailable);
      }
    },
    applySubject(vo) {
      const d = vo || {};
      this.wechatImg = d.contactWeixinImg || this.wechatImg;
      this.phone = d.contactPhone || this.phone;
    },
    // 老端 getSubjectInfo 会把运营商配置写入 localStorage，同域下可直接复用
    readCachedSubject() {
      try {
        return JSON.parse(localStorage.getItem("subjectVO")) || {};
      } catch (e) {
        return {};
      }
    },
    close() {
      this.innerVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.kefu-inner {
  position: relative;
  padding: 20px 14px;
  text-align: center;
}
.kefu-title {
  position: relative;
  display: inline-block;
  margin: 0;
  font-size: 18px;
  line-height: 18px;
  color: #333;
  &::after {
    content: "";
    position: absolute;
    left: 35%;
    right: 35%;
    bottom: -8px;
    height: 2px;
    background: #64c3a4;
  }
}
.kefu-tip {
  margin: 25px 0 0;
  font-size: 14px;
  line-height: 14px;
  color: #999;
}
.kefu-img-wrap {
  width: 180px;
  height: 180px;
  margin: 8px auto;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #eee;
  border-radius: 10px;
  .kefu-wechat {
    display: block;
    width: 100%;
    height: 100%;
  }
}
.kefu-phone-box {
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
  color: #999;
  font-size: 14px;
  .phone-label {
    margin: 0;
    line-height: 14px;
  }
  .phone {
    margin: 10px 0 0;
    font-size: 24px;
    color: #35a2fe;
  }
}
.kefu-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  // 灰色关闭图标（复用老端 ico-close.png）：
  // 原用 common/cross_ico.png 是纯白图标，放在白底弹框上完全不可见
  background: url("~@/assets/images/pro-plan/plan/kefu-close.png") no-repeat
    center;
  background-size: 16px;
  opacity: 0.6;
  &:hover {
    opacity: 1;
  }
}
</style>

<style lang="scss">
/* 弹框本体无内边距，内容区自带 20px 14px，避免二维码贴边 */
.kefu-dialog {
  border-radius: 10px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
  }
}

/* 页面内垂直居中（与老端 initKefu 的 .kefu_dialog flex 居中一致）
   el-dialog 默认 margin-top: 15vh 会明显偏上；用 flex + margin:auto 居中，
   相比 align-items:center，内容超高时也不会被裁掉顶部。
   wrapper 由 JS 打标（Element UI 的 el-dialog 无 wrapper class 属性） */
.kefu-dialog-wrapper {
  display: flex;
  .el-dialog.kefu-dialog {
    margin: auto !important;
  }
}
</style>
